export default "__VITE_ASSET__BXZDzUsA__"